<template>
  <div class="d-flex justify-content-center align-items-center">
    <input v-model="termsAccepted" type="checkbox" style="cursor: pointer" :disabled="disabled"/>
    &nbsp;I agree to the&nbsp; <div class="btn-link" @click="displayTerms" style="cursor: pointer">Terms & Conditions.</div>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditionsCheckbox',
  props: {
    value: Boolean,
    disabled: Boolean
  },
  computed: {
    termsAccepted: {
      get () {
        return !!this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    displayTerms () {
      this.$emit('displayTerms')
    }
  }
}
</script>
